<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-card>
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="9">
          <span class="title_class">账号信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        label-width="80px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="用户名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="searchFn"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="resetFn"
            >重置</el-button
          >
        </el-col>
      </el-row>
      </el-form>
    </el-card>
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="12">
          <span class="title_class">账号信息列表</span>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <el-button type="primary" @click="showDialog(null)"
            >添加账号</el-button
          >
        </el-col>
      </el-row>
      <!-- 用户列表表格区域 -->
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="accountList"
        border
        stripe
      >
        <!-- <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table
              header-cell-class-name="tableHeaderStyle"
              :data="scope.row.userList"
              border
              stripe
            >
              <el-table-column label="部门" prop="deptName"></el-table-column>
              <el-table-column label="角色" prop="roleName"></el-table-column>
              <el-table-column  label="赛区数">
                <template slot-scope="scope">
                  <span v-if="scope.row.districts">{{scope.row.districts.length}}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="showEditUserDialog(scope.row.userId)"
                  ></el-button>
                  <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    @click="
                      showDeleteUserTip(scope.row.mainId, scope.row.userId)
                    "
                  ></el-button>
                  <el-button
                    type="warning"
                    icon="el-icon-plus"
                    size="mini"
                    @click="
                      showDistrictTip(scope.row)
                    "
                  >分配赛区</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column> -->
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="用户名" prop="userName"></el-table-column>
        <el-table-column label="电话" prop="phone"></el-table-column>
        <el-table-column label="邮箱" prop="email"></el-table-column>
        <el-table-column label="状态" prop="userStatus">
          <template slot-scope="scope">
            <el-tag :type="scope.row.userStatus === 1 ? 'success' : 'danger'" size="mini">
              {{ scope.row.userStatus === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              size="mini"
              @click="showDialog(scope.row)"
            >修改</el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              size="mini"
              style="color: rgb(245, 108, 108);"
              @click="showDeleteAccountTip(scope.row.id)"
            >删除</el-button>
            <!-- <el-tooltip
              effect="text"
              content="添加岗位"
              placement="top"
              :enterable="false"
            >
              <el-button
                type="warning"
                icon="el-icon-plus"
                size="mini"
                @click="showAddUserDialog(scope.row.id, scope.row.username)"
              ></el-button>
            </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="title + '账户信息'"
      :visible.sync="visible"
      width="500px"
      :close-on-click-modal="false"
      @close="dialogCloseFn"
    >
    <el-form
        :model="editForm"
        label-width="100px"
        ref="editFormRef"
        :rules="editFormRules"
        style="width: 100%"
      >
        <el-form-item label="用户名" prop="userName">
          <el-input
            v-model="editForm.userName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="editForm.phone" placeholder="请输入">
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="editForm.email"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="editForm.sex">
            <el-radio :label="1">女</el-radio>
            <el-radio :label="2">男</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="userStatus">
          <el-switch v-model="editForm.userStatus"
          :active-value="1"
          :inactive-value="0"></el-switch>
          <span style="margin-left: 12px;">{{ editForm.userStatus === 1 ? '启用' : '禁用' }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAccount, addAccount, delAccount } from '@/http/api'
export default {
  name: 'account',
  data () {
    return {
      queryForm: {
        userName: '',
        phone: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      accountList: [],
      visible: false,
      title: '',
      editType: 0,
      editForm: {
        userName: '',
        phone: '',
        email: '',
        userStatus: 1,
        sex: 1,
        id: 0
      },
      editFormRules: {
        userName: [{ required: true, message: '请输入', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入', trigger: 'blur' }],
        email: [{ required: true, message: '请输入', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getList () {
      getAccount(this.queryForm).then(res => {
        this.accountList = res.data.list
        this.total = res.data.total
      })
    },
    searchFn () {
      this.queryForm.pageNum = 1
      this.getList()
    },
    resetFn () {
      this.$refs.queryFormRef.resetFields()
      this.getList()
    },
    handleCurrentChange (e) {
      this.queryForm.pageNum = e
      this.getList()
    },
    handleSizeChange (e) {
      this.queryForm.pageSize = e
      this.getList()
    },
    showDialog (item) {
      this.visible = true
      this.title = item ? '修改' : '添加'
      this.editType = item ? 1 : 0
      if (item) {
        this.editForm = {
          userName: item.userName,
          phone: item.phone,
          email: item.email,
          userStatus: item.userStatus,
          sex: item.sex,
          id: item.id
        }
      } else {
        this.editForm = {
          userName: '',
          phone: '',
          email: '',
          userStatus: 1,
          sex: 1,
          id: 0
        }
      }
    },
    showDeleteAccountTip (id) {
      this.$confirm('确定删除此账户？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(id)
        delAccount({ id }).then(res => {
          this.searchFn()
          this.$message.success('已删除')
        })
      })
    },
    dialogCloseFn () {
      this.visible = false
    },
    saveFn () {
      console.log(this.editForm)
      if (!this.editForm.id) {
        delete this.editForm.id
      }

      this.$refs.editFormRef.validate(valid => {
        if (!valid) return
        addAccount(this.editForm).then(res => {
          this.$message.success(`${this.title}成功`)
          if (this.editType) {
            this.getList()
          } else {
            this.searchFn()
          }
          this.visible = false
        })
      })
    }
  }
}

</script>
